export class BT {
  id: number;
  indice: number;
  number: number;

  constructor(number?: number, indice?: number, id?: number) {
    this.number = number;
    this.indice = indice;
    this.id = id;
  }

  public toString() {
    return this.number + '/' + this.indice;
  }

  public convertStringsToNumbers(): BT {
    this.number = Number(this.number);
    this.indice = Number(this.indice);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/bt.ts